import { createStyles } from '@mui/styles';
import { APTheme } from "../../../core/TenantProvider/tenants";

export default (theme: APTheme) =>
  createStyles({
    "@keyframes onloadup": {
      "0%": {
        opacity: 0,
        transform: "translateY(65px)"
      },
      "100%": {
        opacity: 1,
        transform: "translateY(0)"
      }
    },
    loginContainer: {
      display: "flex",
      justifyContent: "center",
      animationName: `$onloadup`,
      animationDuration: '0.3s',
      animationFillMode: 'both',
      animationTimingFunction: 'cubic-bezier(0.680, -0.550, 0.265, 1.550) both',
    },
    loginContent: {
      width: "100%",
      padding: '9em 0 4em 0',
      [theme.breakpoints.down('lg')]: {
        padding: '6em 0 4em 0',
      },
    },
    loginContentWithMessage: {
      padding: '7em 0 4em 0',
    },
    loginInput: {
      width: "100%",
      marginBottom: 25
    },
    loginIntro: {
      maxWidth: 460,
      margin: 'auto',
      padding: '0 16px',
      '& h4': {
        fontSize: '2.6rem',
        letterSpacing: '-1px',
        marginBottom: 20,
        [theme.breakpoints.down('sm')]: {
          fontSize: '2.0rem',
        },
      },
    },
    loginForm: {
      maxWidth: 460,
      margin: 'auto',
      padding: '0 16px',
    },
    loginIntroHeader: {
      marginBottom: 30,
      textAlign: "center",
    },
    loginHeaderSA: {
      width: '20px',
      height: '20px',
      marginLeft: '15px',
      position: 'relative',
      top: '2px'
    },
    loginIntroText: {
      display: "block",
      marginBottom: 50,
      textAlign: "center",
    },
    loginActions: {
      display: "flex",
      justifyContent: "center",
      marginTop: 25,
    },
    loginButton: {
      width: "200px",
      [theme.breakpoints.down('md')]: {
        width: "100%",
      },
    },
    inputsSurround: {
      display: "inline-grid",
      width: "100%",
      position: 'relative',
    },
    inputWrapper: {
      position: 'relative',
    },
    error: {
      color: "#FF5F5F",
      fontSize: "12px",
      lineHeight: "18px",
      marginTop: 16
    },
    link: {
      color: "#2D91E9",
      textDecoration: "none",
      fontSize: "16px",
      margin: "-10px 0 0 8px",
      display: "inline-block",
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.4rem',
        lineHeight: 1.45
      },
    }
  });